/*
 * @Author: 刘小博
 * @Date: 2023-02-07 17:21:52
 * @LastEditTime: 2023-02-08 10:41:52
 * @LastEditors: 刘小博
 * @Description: 
 * @FilePath: \p2ps_vip_web\src\router\behavior-manage\oa-work-manage\index.js
 * OA办公管理
 */
import workManageRouter from './modules/workManageRouter'

const oaWorkManageRouter = [].concat(workManageRouter)
export default oaWorkManageRouter
